
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

@Component
export default class FooterBlock extends Vue {
  get isH5() {
    return AppModule.isH5
  }
}
